import { warehouseValidate } from '../../application/dtos/warehouse_validate'

export class warehouseEntity {
    constructor({id, name, country, state, zipcode, municipality, neighborhood, street, external_number, internal_number, picking_required, warehouse_type, group, deleted_at, updated_at, created_at}){
        this.id = id;
        this.name = name;
        this.country = country;
        this.state = state;
        this.zipcode = zipcode; 
        this.municipality = municipality;
        this.neighborhood = neighborhood; 
        this.street = street;
        this.external_number = external_number;
        this.internal_number = internal_number;
        this.picking_required = picking_required;
        this.warehouse_type = warehouse_type;
        this.group = group;
        this.deleted_at = deleted_at;
        this.created_at = created_at;
        this.updated_at = updated_at;
    }

    isValid() {
        return warehouseValidate(this);
    }
}